module.exports = __webpack_public_path__ + "images/category_lp/watch/omega_samples/sec04_sp_9a5c576382ddb03ea4a1dae125b54568.jpg";